import React from 'react';
import axios from 'axios';
import ServiceItemCard from '../components/ServiceItemCard';
import Banner from '../components/Banner';

function ServicesPage() {
  const [services, setServices] = React.useState([]);

  React.useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/service`)
      .then(res => setServices(res.data))
      .catch(err => console.error(err));
  }, []);
// min-h-screen py-10 px-6 max-w-5xl
  return (
    <>
    <Banner title="服務項目" backgroundImage="" />
    <div className=" max-w-6xl py-10 px-6 min-h-screen mx-auto ">  
      {/* <h2 className="text-3xl font-ec mb-10 text-center text-gray-800">
        本所服務項目
      </h2> */}
      <div>
        {services.map(item => (
          <ServiceItemCard
            key={item.id}
            title={item.title}
            description={item.description}
            imageUrl={item.imageUrl}
          />
        ))}
      </div>
    </div>
    </>
  );
}
export default ServicesPage;

